export const environment = {
  production: true,
  client_id: 'f7cc54fd-36c2-4ee2-8418-dbb2f2552357',
  authority:
    'https://login.microsoftonline.com/5dbf1add-202a-4b8d-815b-bf0fb024e033',
  product_name: 'ExpertGuidance Build Management Portal',
  product_version: 'VA27A',
  front_end_version: '4.0.4',
  windows_QR_Code: 'https://moa-storage-stage.s3.eu-west-1.amazonaws.com/eg_assets/Stage-Windows-QR-Code.png',
};
